import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { Product } from '@spartacus/core'

@Component({
    selector: 'app-action-button',
    templateUrl: './action-button.component.html',
    styleUrls: ['./action-button.component.scss'],
    standalone: false
})
export class ActionButtonComponent implements OnInit {
  @Input() title: string
  @Input() image: any
  @Input() product?: Product
  // tslint:disable-next-line: no-inferrable-types
  @Input() closeButton?: boolean = false
  @Output() public readonly removeProductToCompare = new EventEmitter<Product>()

  constructor() {}

  ngOnInit(): void {}

  onClocseClicked(product: Product): void {
    this.removeProductToCompare.emit(product)
  }
}
